module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"status":{"stopped":"Выключен","suspended":"Неактивен","running":"Включён"}}}')
  delete Component.options._Ctor
}
